import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider, Grid, TextField, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { PostPaymnetApproval } from 'API/PaymentRequest/api';
import { IoClose } from "react-icons/io5";




function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const calculateTotal=(data)=>{
  let sum=0;
  for(let i=0;i<data.length;i++){
    sum+=parseInt(data[i].amount)
  }
  return sum
}

export default function RequestDialog(props) {

  const [value, setValue] = React.useState(0);
  const [postData, setPostData] = useState(0)
  const [HardwareAmount,setHardwareAmount] = useState(0)
  const [remarks, setRemarks] = useState(null)
  const [open, setOpen] = useState(false)
  const [errorType, setErrorType] = useState('success')
  const [errorMessage, setErrorMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleAlertOpen = () => {
    setOpen(true)
  }

  const handleAlertClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    setPostData(0)
    setHardwareAmount(0)
    setRemarks(null)
  }, [props.handleClose])

  const handleDataChange = (data) => {
    // console.log(eval(parseInt(postData)+parseInt(data)));
    if (/^\d*$/.test(data) && (props.data.agent_details.payment_details.installment_1.total_amount >= (parseInt(data&&data!==''?data:0) + parseInt(HardwareAmount&&HardwareAmount!==''?HardwareAmount:0)))) {
        setPostData(data)
      }
  }

  const handleHardwareChange = (data) => {
    // console.log(eval(parse(postData)+data));
    
    if (/^\d*$/.test(data) === true&&(props.data.agent_details.payment_details.installment_1.total_amount>=(eval(parseInt(postData&&postData!==''?postData:0)+parseInt(data&&data!==''?data:0))))) {
        setHardwareAmount(data)
    }
  }

  const handleRemarksChange = (data) => {
    if (/^[a-zA-Z0-9\s]*$/.test(data)) {
      setRemarks(data)
    }
  }

  const handlePosdata = () => {
    if (postData === '' || !postData ||postData===0) {
      PostPaymnetApproval({ request_id: props.data._id, remarks: remarks, sh_signon_updated_amount: 0,sh_hardware_updated_amount:!HardwareAmount||HardwareAmount===''||HardwareAmount===0?0:parseInt(HardwareAmount), approval_status: true }, setErrorMessage, setErrorType, handleAlertOpen, props.handleClose, setIsLoading);
    }
    else {
      PostPaymnetApproval({ request_id: props.data._id, remarks: remarks, sh_signon_updated_amount: parseInt(postData),sh_hardware_updated_amount:!HardwareAmount||HardwareAmount===''?0:parseInt(HardwareAmount), approval_status: true }, setErrorMessage, setErrorType, handleAlertOpen, props.handleClose, setIsLoading);
    }
  }

  const handlePostCsodata = () => {
    if (postData === '' || postData===0||!postData) {
      PostPaymnetApproval({ request_id: props.data._id, remarks: remarks, rm_signon_updated_amount: parseInt(postData),rm_hardware_updated_amount:!HardwareAmount||HardwareAmount===''||HardwareAmount===0?0:parseInt(HardwareAmount), approval_status: true }, setErrorMessage, setErrorType, handleAlertOpen, props.handleClose, setIsLoading);
    }
    else {
      PostPaymnetApproval({ request_id: props.data._id, remarks: remarks, rm_signon_updated_amount: parseInt(postData),rm_hardware_updated_amount:!HardwareAmount||HardwareAmount===''?0:parseInt(HardwareAmount), approval_status: true }, setErrorMessage, setErrorType, handleAlertOpen, props.handleClose, setIsLoading);
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  console.log("props at dialog", props);
  return (
    <Grid container>
      <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert
          onClose={handleAlertClose}
          severity={errorType}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      <Grid item xl={12}>

        <Dialog
          open={props.open}
          onClose={props.handleClose}
          maxWidth={'md'}

          fullWidth={true}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Box sx={{ position: 'absolute', top: '8px', right: '8px', cursor: 'pointer', fontSize: '20px' }} onClick={props.handleClose}>
            <IoClose />
          </Box>
          <DialogTitle id="alert-dialog-title">
            <Typography variant='h3'>Payment request</Typography>
          </DialogTitle>
          <DialogContent >
            <Grid container spacing={2} mb={5} justifyContent='flex-start' alignItems='center' p={1}>
              <Grid item xl={3}>
                <TextField
                  value={postData ? postData : ''}
                  label='Signon Amount'
                  size='small'
                  onChange={(e) => /^\d*$/.test(e.target.value) && props.data && props.data.agent_details.payment_details.installment_1.signon_amount >= e.target.value ? handleDataChange(e.target.value) : alert("Value exceeds the product signon amount")}
                  disabled={(sessionStorage.getItem('UserType') === 'sh' && props.data !== null && !props.data.sh_approval_status) || (sessionStorage.getItem('UserType') === 'rm' && props.data !== null && !props.data.rm_approval_status) ? false : true}
                />
              </Grid>

              <Grid item xl={3}>
                <TextField
                  value={HardwareAmount ? HardwareAmount : ''}
                  label='Hardware Amount'
                  size='small'
                  onChange={(e) => /^\d*$/.test(e.target.value) && props.data &&props.data.agent_details.device_details && calculateTotal(props.data.agent_details.device_details) >= e.target.value ? handleHardwareChange(e.target.value) : alert("Value exceeds the hardware requested")}
                  disabled={(
                    ((sessionStorage.getItem('UserType') === 'sh' && props.data !== null && !props.data.sh_approval_status) || (sessionStorage.getItem('UserType') === 'rm' && props.data !== null && !props.data.rm_approval_status) ||(props.data&&!props.data.agent_details.payment_details.installment_1.device_amount)) 
                    && 
                    (props.data&&props.data.agent_details&&props.data.agent_details.device_id && props.data.agent_details.device_id.length>0))   ?false:true}
                />
              </Grid>

              <Grid item xl={3}>
                <TextField
                  value={remarks ? remarks : ''}
                  label='Remarks' size='small'
                  disabled={(sessionStorage.getItem('UserType') === 'sh' && props.data !== null && !props.data.sh_approval_status) || (sessionStorage.getItem('UserType') === 'rm' && props.data !== null && !props.data.rm_approval_status) ? false : true}
                  onChange={(e) => handleRemarksChange(e.target.value)}
                />
              </Grid>
              {
                (sessionStorage.getItem('UserType') === 'sh' && props.data !== null && !props.data.sh_approval_status) || (sessionStorage.getItem('UserType') === 'rm' && props.data !== null && (!props.data.rm_approval_status) ) ?
                  <Grid item xl={3} >
                    <Button sx={{ borderRadius: '10px' }} disabled={isLoading} variant='contained' fullWidth color='success' onClick={() =>sessionStorage.getItem("UserType")==="sh"? handlePosdata():handlePostCsodata()}>Approve</Button>
                  </Grid>
                  :
                  <Grid item xl={3} >
                    <Button sx={{ borderRadius: '10px' }} variant='outlined' fullWidth color='error' >Already approved</Button>
                  </Grid>
              }


            </Grid>
            <Divider />
            <Grid container sx={{ minHeight: '40vh' }}>
              <Grid item xl={12} lg={12} md={12}>
                <Box sx={{ width: '100%' }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                      <Tab label="Information" {...a11yProps(0)} />
                      <Tab label="Details" {...a11yProps(1)} />
                      <Tab label="Remarks" {...a11yProps(2)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={value} index={0}>
                    <table>

                      <tr>
                        <th style={{ textAlign: 'left' }}>Bank Name</th>
                        <td>:</td>
                        <td>{props.data && props.data.agent_details.product_details ? props.data.agent_details.product_details[0].display_name : ''}</td>
                      </tr>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Hardware Devices</th>
                        <td>:</td>
                        <td>{props.data && props.data.agent_details.device_details ? props.data.agent_details.device_details.map((item) => item.name).join(',') : '0'}</td>
                      </tr>

                      <tr>
                        <th style={{ textAlign: 'left' }}>Total Amount</th>
                        <td>:</td>
                        <td>{props.data ? props.data.agent_details.payment_details.installment_1.total_amount : ''}</td>
                      </tr>
                      {
                        sessionStorage.getItem("UserType") === 'rm' && props.data && (props.data.request_type === 'tm_initiated' || props.data.request_type === 'ds_initiated' || props.data.request_type === 'ops_initiated') && (props.data.sh_hardware_updated_amount > 0||props.data.sh_signon_updated_amount>0) ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>Requested Amount</th>
                            <td>:</td>
                            <td>{props.data ? eval(parseInt(props.data.sh_signon_updated_amount)+parseInt(props.data.sh_hardware_updated_amount)) : ''}</td>
                          </tr>
                          :
                          <tr>
                            <th style={{ textAlign: 'left' }}>Requested Amount</th>
                            <td>:</td>
                            <td>{props.data ? props.data.agent_details.payment_details.installment_1.payment_requested ? props.data.agent_details.payment_details.installment_1.payment_requested : props.data.agent_details.payment_details.installment_1.payment_requested : ''}</td>
                          </tr>

                      }

                      {
                        sessionStorage.getItem("UserType") === 'rm' && props.data && (props.data.request_type === 'tm_initiated' || props.data.request_type === 'ds_initiated' || props.data.request_type === 'ops_initiated') && props.data.sh_hardware_updated_amount > 0 ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>Hardware Amount</th>
                            <td>:</td>
                            <td>{props.data ? props.data.sh_hardware_updated_amount : ''}</td>
                          </tr>
                          :
                          <tr>
                            <th style={{ textAlign: 'left' }}>Hardware Amount</th>
                            <td>:</td>
                            <td>{props.data ? props.data.agent_details.payment_details.installment_1.hardware_payment_requested ? props.data.agent_details.payment_details.installment_1.hardware_payment_requested : '-' : ''}</td>
                          </tr>

                      }

                      {
                        sessionStorage.getItem("UserType") === 'rm' && props.data && (props.data.request_type === 'tm_initiated' || props.data.request_type === 'ds_initiated' || props.data.request_type === 'ops_initiated') && props.data.sh_signon_updated_amount > 0 ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>Signon Amount</th>
                            <td>:</td>
                            <td>{props.data ? props.data.sh_signon_updated_amount : ''}</td>
                          </tr>
                          :
                          <tr>
                            <th style={{ textAlign: 'left' }}>Signon Amount</th>
                            <td>:</td>
                            <td>{props.data ? props.data.agent_details.payment_details.installment_1.signon_payment_requested ? props.data.agent_details.payment_details.installment_1.signon_payment_requested : '-' : ''}</td>
                          </tr>

                      }


                      <tr>
                        <th style={{ textAlign: 'left' }}>Due Amount</th>
                        <td>:</td>
                        {
                          sessionStorage.getItem("UserType") === 'rm' && props.data && (props.data.request_type === 'tm_initiated' || props.data.request_type === 'ds_initiated' || props.data.request_type === 'ops_initiated') &&(( props.data.sh_signon_updated_amount > 0 )||( props.data.sh_hardware_updated_amount > 0 ))?
                            <td>{props.data ? (props.data.agent_details.payment_details.installment_1.total_amount) - (props.data.sh_signon_updated_amount?props.data.sh_signon_updated_amount:0-props.data.sh_hardware_updated_amount?props.data.sh_hardware_updated_amount:0) : ''}</td>
                            :
                            <td>{props.data ? (props.data.agent_details.payment_details.installment_1.total_amount) - (props.data.agent_details.payment_details.installment_1.payment_requested ? props.data.agent_details.payment_details.installment_1.payment_requested : props.data.agent_details.payment_details.installment_1.payment_requested) : ''}</td>

                        }
                      </tr>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Due Date</th>
                        <td>:</td>
                        <td>{props.data ? props.data.agent_details.payment_details.installment_1.due_date : ''}</td>
                      </tr>

                      {/* {
                        
                        sessionStorage.getItem("UserType") === 'rm' &&props.data&&(props.data.request_type==='tm_initiated'||props.data.request_type==='ds_initiated'||props.data.request_type==='ops_initiated')&&props.data.sh_updated_amount>0?
                          <tr>
                            <th style={{ textAlign: 'left' }}>SH Updated Amount</th>
                            <td>:</td>
                            <td>{props.data ? props.data.sh_updated_amount : ''}</td>
                          </tr>
                          :
                          null
                      } */}

                      {
                        sessionStorage.getItem("UserType") === 'rm' && props.data && (props.data.request_type === 'tm_initiated' || props.data.request_type === 'ds_initiated' || props.data.request_type === 'ops_initiated') ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>{props.data.request_type === 'tm_initiated' ? "TM Requested Amount" : props.data.request_type === 'ops_initiated' ? "Ops requested Amount" : props.data.request_type === 'sh_initiated' ? "SH Requested Amount" : "DS Requested Amount"}</th>
                            <td>:</td>
                            <td>{props.data ? props.data.agent_details.payment_details.installment_1.payment_requested : ''}</td>
                          </tr>
                          :
                          null
                      }
                    </table>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={1}>
                    <table>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Agent Name</th>
                        <td>:</td>
                        <td>{props.data ? props.data.agent_details.customer_details.customer_name : ''}</td>
                      </tr>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Mobile Number</th>
                        <td>:</td>
                        <td>{props.data ? props.data.agent_details.customer_details.customer_mobile : ''}</td>
                      </tr>

                      <tr>
                        <th style={{ textAlign: 'left' }}>Email Address</th>
                        <td>:</td>
                        <td>{props.data ? props.data.agent_details.customer_details.customer_email : ''}</td>
                      </tr>

                      <tr>
                        <th style={{ textAlign: 'left' }}>Location</th>
                        <td>:</td>
                        <td>{props.data ? props.data.agent_details.customer_details.retail_district + "," + props.data.agent_details.customer_details.retail_state : ''}</td>
                      </tr>


                    </table>
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={2}>
                    <table>
                      {
                        sessionStorage.getItem('UserType') === 'sh' || sessionStorage.getItem('UserType') === 'rm' ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>DS Remarks</th>
                            <td>:</td>
                            <td>{props.data ? props.data.ds_remarks ? props.data.ds_remarks : '-' : ''}</td>
                          </tr>
                          :
                          null
                      }

                      {
                        sessionStorage.getItem('UserType') === 'sh' || sessionStorage.getItem('UserType') === 'rm' ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>TM Remarks</th>
                            <td>:</td>
                            <td>{props.data ? props.data.tm_remarks ? props.data.tm_remarks : '-' : ''}</td>
                          </tr>
                          :
                          null
                      }

                      {
                        sessionStorage.getItem('UserType') === 'rm' ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>SH Remarks</th>
                            <td>:</td>
                            <td>{props.data ? props.data.sh_remarks ? props.data.sh_remarks : '-' : ''}</td>
                          </tr>
                          :
                          null
                      }

                      {
                        sessionStorage.getItem('UserType') === 'sh' || sessionStorage.getItem('UserType') === 'rm' ?
                          <tr>
                            <th style={{ textAlign: 'left' }}>OPS Remarks</th>
                            <td>:</td>
                            <td>{props.data ? props.data.ops_remarks ? props.data.ops_remarks : '-' : ''}</td>
                          </tr>
                          :
                          null
                      }




                    </table>
                  </CustomTabPanel>

                </Box>
              </Grid>
            </Grid>
          </DialogContent>

        </Dialog>
      </Grid>
    </Grid>
  );
}
